import { useQuery } from '@tanstack/react-query'
import { supabase } from '@/lib/supabase'
import type { FilterDefinition, FilterType } from '@/types'

export function useFilterDefinitions() {
  return useQuery({
    queryKey: ['filter-definitions'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('filter_definitions')
        .select('*')
        .order('sort_order', { ascending: true })

      if (error) throw error

      // Group by type
      const grouped = (data as FilterDefinition[]).reduce(
        (acc, filter) => {
          if (!acc[filter.type]) {
            acc[filter.type] = []
          }
          acc[filter.type].push(filter)
          return acc
        },
        {} as Record<FilterType, FilterDefinition[]>
      )

      return grouped
    },
  })
}

export const filterTypeLabels: Record<FilterType, string> = {
  water_tightness: 'Water Tightness',
  fire_class: 'Fire Class',
  material: 'Material',
  product: 'Products',
}
